import { DragEvent, ChangeEvent, RefObject, useRef, useState, useCallback, MouseEvent } from "react";
import { HtmlReactParser, translate } from "@kaltura/mediaspace-shared-utils";
import {
    StyledBox,
    StyledDragAndDropIllustration,
    StyledDragAndDropIllustration200,
    StyledHiddenInput,
    StyledText,
} from "./StyleComponents";
import { Button, Typography } from "@kaltura/ds-react-components";

export type DragAndDropProps = {
    allowedFilesType: string;
    fullSize: boolean;
    onDrop: (e: DragEvent<HTMLDivElement>) => void;
    onSelect: (e: ChangeEvent<HTMLInputElement>) => void;
    singleUpload?: boolean;
    smallIllustration?: boolean;
};

const DragAndDrop = ({
    allowedFilesType,
    fullSize,
    onDrop,
    onSelect,
    singleUpload,
    smallIllustration,
}: DragAndDropProps) => {
    const [dropzoneActive, setDropzoneActive] = useState(false);

    const filesUploadRef = useRef<HTMLInputElement>(null);

    /**
     * show the native files selector
     */
    const onClicked = useCallback(() => {
        if (!filesUploadRef || !filesUploadRef.current) {
            return;
        }

        filesUploadRef.current.click();
    }, []);

    return (
        <StyledBox
            draggable={true}
            onDragOver={(e) => {
                setDropzoneActive(true);
                e.preventDefault();
            }}
            onDragLeave={(e) => {
                setDropzoneActive(false);
                e.preventDefault();
            }}
            onDrop={(e) => {
                onDrop(e);
                setDropzoneActive(false);
            }}
            fullSize={fullSize}
            withColor={dropzoneActive}
            className={"kms-ds-upload-media-drag-and-drop"}
        >
            {fullSize && (
                <div>
                    {smallIllustration && <StyledDragAndDropIllustration200 />}
                    {!smallIllustration && <StyledDragAndDropIllustration />}
                </div>
            )}
            <Typography component={"h2"} variant={"h3"}>
                {singleUpload
                    ? HtmlReactParser(translate("Drag and drop a file to upload"))
                    : HtmlReactParser(translate("Drag and drop files to upload"))}
            </Typography>
            <StyledText variant={"body1"}>
                {HtmlReactParser(
                    translate("All common video, audio and image formats in all resolutions are accepted.")
                )}
            </StyledText>
            <StyledHiddenInput
                ref={filesUploadRef}
                type="file"
                multiple={!singleUpload}
                accept={allowedFilesType}
                onChange={(e) => onSelect(e)}
                onClick={(e: MouseEvent<HTMLInputElement>) => {
                    e.currentTarget.value = "";
                }}
            />
            <div>
                <Button onClick={onClicked} className={"kms-ds-upload-media-drag-and-drop-button"}>
                    {singleUpload ? translate("Select a file") : translate("Select files")}
                </Button>
            </div>
        </StyledBox>
    );
};

export default DragAndDrop;
